import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, StringField, Int32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class MIDIControllerBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new MIDIControllerBox({
            uuid,
            graph,
            name: "MIDIControllerBox",
            pointerRules: NoPointers,
            resource: undefined,
            ephemeral: true,
        }), constructor);
    }
    static ClassName = "MIDIControllerBox";
    static Resource = undefined;
    static Ephemeral = true;
    static Tags = Object.freeze({});
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitMIDIControllerBox, this);
    }
    get tags() {
        return MIDIControllerBox.Tags;
    }
    get controllers() {
        return this.getField(1);
    }
    get parameter() {
        return this.getField(2);
    }
    get deviceId() {
        return this.getField(3);
    }
    get deviceChannel() {
        return this.getField(4);
    }
    get controlId() {
        return this.getField(5);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "controllers",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.MIDIControllers, true),
            2: PointerField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "parameter",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.MIDIControl, true),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "deviceId",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            4: Int32Field.create({
                parent: this,
                fieldKey: 4,
                fieldName: "deviceChannel",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 127 }, ""),
            5: Int32Field.create({
                parent: this,
                fieldKey: 5,
                fieldName: "controlId",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 127 }, ""),
        };
    }
}
